import { render, staticRenderFns } from "./PagePromotedUsers.vue?vue&type=template&id=1b0db26d&scoped=true&"
import script from "./PagePromotedUsers.vue?vue&type=script&lang=ts&"
export * from "./PagePromotedUsers.vue?vue&type=script&lang=ts&"
import style0 from "./PagePromotedUsers.vue?vue&type=style&index=0&id=1b0db26d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0db26d",
  null
  
)

export default component.exports